import * as LmsActions from './lms-activities.actions';
import _ from 'lodash';

export interface LmsState {
  labInfo: any;
  numAssignedKits: number;
  kitsAvailable: boolean;
  invalidCap: boolean;
  labsHavingKits: any[];
  kits: any[];
  activity;
  headline: string;
  enterCap: boolean;
  hasLabAffiliation: boolean;
  dataFromLmsService;
  showConfirmation: boolean;
  allKitsUsed: boolean;
  affiliationSuccess: boolean;
  showLabSelect: boolean;
  assignmentStatus: string;
  kitsFulfilled: boolean;
  qMedActivityNotAvailable: boolean;
}

const initialState = {
  labInfo: {},
  numAssignedKits: 0,
  kitsAvailable: true,
  invalidCap: false,
  labsHavingKits: [],
  kits: [],
  activity: {},
  headline: null,
  enterCap: false,
  hasLabAffiliation: true,
  dataFromLmsService: null,
  showConfirmation: false,
  allKitsUsed: false,
  affiliationSuccess: false,
  showLabSelect: false,
  assignmentStatus: '',
  kitsFulfilled: true,
  qMedActivityNotAvailable: false,
};

export function lmsReducer(
  state: LmsState = initialState,
  action: LmsActions.LmsActions
) {
  switch (action.type) {
    case LmsActions.GET_LAB_INFO_SUCCESS:
      return {
        ...state,
        labInfo: action.payload,
        showConfirmation: true,
        invalidCap: false,
      };
    case LmsActions.GET_LAB_INFO_FAILURE:
      return {
        ...state,
        invalidCap: true,
        enterCap: true,
      };
    case LmsActions.GET_LAB_SELECT_DATA_SUCCESS:
      let kitsFulfilled = true;
      action.payload.kits.forEach((kit) => {
        if (!kit.fulfilled) {
          kitsFulfilled = false;
        }
      });

      return {
        ...state,
        kits: action.payload.kits,
        headline: action.payload.activity
          ? action.payload.activity.activityDescription
          : null,
        hasLabAffiliation: !_.isEmpty(action.payload.affiliatedLabs),
        labsHavingKits: kitsFulfilled ? action.payload.labsHavingKits : [],
        enterCap:
          _.isEmpty(action.payload.affiliatedLabs) ||
          _.isEmpty(action.payload.labsHavingKits) ||
          !kitsFulfilled,
        dataFromLmsService: action.payload,
        activity: action.payload.activity,
        showLabSelect: true,
        isLoading: false,
         kitsFulfilled,
            };
    case LmsActions.AFFILIATE_USER_TO_LAB_SUCCESS:
      return {
        ...state,
        affiliationSuccess: true,
        showConfirmation: false,
        kitsAvailable: true,
        invalidCap: false,
        hasLabAffiliation: true,
      };
    case LmsActions.ASSIGN_KIT_TO_USER_SUCCESS:
      return {
        ...state,
        kitsAvailable: action.payload !== 'E_NO_KITS_AVAILABLE',
        affiliationSuccess: state.enterCap,
        showConfirmation: false,
        assignmentStatus: action.payload,
        hasLabAffiliation: true,
      };
    case LmsActions.ENTER_CAP:
      return {
        ...state,
        enterCap: true,
      };
    case LmsActions.SELECT_LAB:
      return {
        ...state,
        enterCap: false,
      };
    case LmsActions.ALL_KITS_USED:
      return {
        ...state,
        allKitsUsed: true,
        showConfirmation: false,
      };
    case LmsActions.KITS_NOT_PURCHASED:
      return {
        ...state,
        kitsAvailable: false,
        showConfirmation: false,
        kitsFulfilled: true,
      };
    case LmsActions.QMED_ACTIVITY_NOT_AVAILABLE:
      return {
        ...state,
        qMedActivityNotAvailable: true,
        showConfirmation: false,
      };
    case LmsActions.CLOSE_CONFIRMATION:
      return {
        ...state,
        showConfirmation: false,
      };
    case LmsActions.KITS_UNFULFILLED:
      return {
        ...state,
        kitsFulfilled: false,
        showConfirmation: false,
      };
    default:
      return state;
  }
}
